module.exports = __webpack_public_path__ + "img/1080_05.b932fb4d.jpg";